import { Component } from '@angular/core';

@Component({
    selector: 'ap-checklist-empty',
    templateUrl: './checklist-empty.component.html',
    styleUrls: ['./checklist-empty.component.css'],
    standalone: false
})
export class ChecklistEmptyComponent {

  constructor() { }

}
